import { render, staticRenderFns } from "./WrongBook.vue?vue&type=template&id=1e299cac&"
import script from "./WrongBook.vue?vue&type=script&lang=js&"
export * from "./WrongBook.vue?vue&type=script&lang=js&"
import style0 from "./WrongBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports